import { CurrencyRangeCategory } from '@lower-financial/lending-web-api/generated';
import { useEffect } from 'react';
import { DidYouKnow, HighlightedText } from '@lightspeed/components/shared/banners/did-you-know';
import { useMortgageAnalytics } from '@lightspeed/hooks/useMortgageAnalytics/use-mortgage-analytics';
import { CardToggleLayout } from '@lightspeed/components/shared/card-toggle-screen-layout/card-toggle-layout';
import { TestimonialSidebar } from '@lightspeed/components/shared/sidebars/testimonial-sidebar';
import { Testimonial } from '@lightspeed/components/ui/molecules/testimonial';
import { useCurrencyRanges } from '@lightspeed/contexts/currency-ranges-context/currency-ranges-context';

const PurchaseDownPaymentDidYouKnow = () => (
  <DidYouKnow>
    Knowing your savings helps us recommend a <HighlightedText>down payment</HighlightedText>
    option that fits your goals.
  </DidYouKnow>
);

const PurchaseDownPaymentTestimonial = () => (
  <Testimonial
    title={'Reliable help every step of the way!'}
    content={'Lower was the best to work with! They helped us every step of the way and were able to answer all our questions for our unique scenario very quickly! Lower made the whole process a breeze. Truly a pleasure.'}
    author={'Joshua Andreson'}
  />
);

export const PurchaseDownPayment = () => {
  const fireAnalyticsEvent = useMortgageAnalytics('purchase_down_payment');
  const { currencyRanges, isLoading } = useCurrencyRanges();

  const options = (currencyRanges ?? [])
    .sort((a, b) => a.minValue - b.minValue)
    .filter((range) => range.category === CurrencyRangeCategory.DownPayment).map((range) => ({
      label: range.label,
      value: range.id,
    }));

  useEffect(() => {
    if (options.length === 0 && !isLoading) {
      throw new Error('No currency ranges found for down payment');
    }
  }, [isLoading, options.length]);

  return (
    <CardToggleLayout
      title={'How much do you have saved to buy a home?'}
      subtitle={<>Down payment options tailored to you!&nbsp;🪡</>}
      mortgageApplicationField={'propertyDownPaymentRangeId'}
      fireAnalyticsEvent={fireAnalyticsEvent}
      cardOptions={options}
      mobileBanner={<PurchaseDownPaymentDidYouKnow />}
      desktopSidebar={(
        <TestimonialSidebar
          testimonial={<PurchaseDownPaymentTestimonial />}
          banner={<PurchaseDownPaymentDidYouKnow />}
        />
      )}
    />
  );
};
